interface IButtonImageControlProps {
    id?: string;
    dataCy?: string;
    className?: string;
    style?: React.CSSProperties;
    isDisabled?: boolean;

    imagePath: string;
    onClick: () => void;
}

function ButtonImageControl(props: IButtonImageControlProps): JSX.Element {
    let classname = props.className;
    if (!props.className)
        classname = "button";

    if (props.isDisabled)
        classname += " disabled";

    return (
        <img
            style={props.style}
            id={props.id}
            className={classname}
            onClick={() => !props.isDisabled && props.onClick()}
            src={props.imagePath}
            data-cy={props.dataCy}
        />
    );
}

export { ButtonImageControl };
